<template>
  <div class="card">
    <div class="establishment-list entity-establishments">
      <h3>
        Establecimientos compradores
        <vs-button @click="addEstablishment">Agregar</vs-button>
      </h3>
      <div class="list">
        <div class="header">
          <div>Nombre</div>
          <div>Nro. Establecimiento</div>
          <div>Localidad</div>
          <div>Usuarios</div>
          <div>Estado</div>
          <div></div>
        </div>
        <div class="content">
          <div v-for="establishment in establishments" :key="establishment.id" class="establishment" >
            <div>{{ establishment.name }}</div>
            <div> <span class="label-mobile">Nro. Establecimiento:</span> {{ establishment.number }}</div>
            <div> <span class="label-mobile">Localidad:</span>{{ establishment.city }}</div>
            <div> <span class="label-mobile">Usuarios:</span> {{ establishment.users.length }}</div>
            <div>
              <span class="label-mobile">Estado:</span>
              <div v-if="(!establishment.active)">Deshabilitado</div>
              <div v-else>Habilitado</div>

              <!--:title="(!editing) ? 'Añadir Establecimiento' : 'Actualizar Establecimiento'"
              <vs-switch v-model="establishment.active" @change="toggleEstablishmentActive(establishment.id, establishment.active)" color="success" /> -->
            </div>
            <div class="actions">
              <button @click="deleting = establishment.id; confirmDelete = true">
                <vs-icon icon="delete"></vs-icon>
                <span>Borrar</span>
              </button>
              <button @click="editEstablishment(establishment.name)"> <!--change name for id-->
                <vs-icon icon="edit"></vs-icon>
                <span>Editar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- TODO: Create popup component -->
    <vs-popup title="Eliminar establecimiento" :active.sync="confirmDelete"  :button-close-hidden="true" class="confirm-action">
      <div class="alert danger">
        <vs-icon icon="warning"></vs-icon>
        <span v-if="canDelete">¿Está seguro que desea eliminar el establecimiento?</span>
        <span v-else>Debe existir al menos un establecimiento.</span>
      </div>

      <div class="footer">
        <button v-show="canDelete" @click="confirmDelete = false; deleting = ''" class="cancel" >  Cancelar</button>
        <button v-show="canDelete" @click="deleteEstablishment(deleting)" class="delete">
          Eliminar
        </button>
        <vs-button v-show="!canDelete" @click="confirmDelete = false" color="success">
          Aceptar
        </vs-button>
      </div>
    </vs-popup>

    <AddEditEstablishments ref="AddEditEstablishments" @get-establishments="getEstablishments" :rol="rol" :vuex="false"></AddEditEstablishments>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'
import AddEditEstablishments from '../../lib/bcrSignUp/components/AddEditEstablishment'

const destroyEstablishment = gql`
  mutation destroyEstablishment($establishmentId: Int!, $currentUserToken: String!) {
    destroyEstablishment( establishmentId: $establishmentId, currentUserToken: $currentUserToken){
      code
      message
      success
    }
  }
`

export default {
  name: 'buyer-establishments-entity',
  components: {
    AddEditEstablishments
  },
  data () {
    return {
      users:[],
      deleting: '',
      popupActive: false,
      confirmDelete: false,
      newEstablishment: { country: '', status: true, activity: "" },
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser,
      vuexEstablishments: state => state.SignUp.establishments
    }),
    establishments () {
      return this.vuexEstablishments[this.$props.rol]
    },
    canDelete() {
      if (this.establishments.length == 1) {
        return false
      }
      return true
    }
  },
  props: {
    rol: {
      type: String,
      required: false,
      default: 'seller'
    },
    roles: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapMutations('SignUp', [
      'pushEstablishment',
      'removeEstablishment',
      'toggleStatusEstablishment'
    ]),
    getEstablishments(){
      this.$emit('get-establishments')
    },
    //toggleEstablishmentActive (id, active) {
    //  axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
    //    query: print(updateEstablishmentMutation),
    //    variables: {
    //      establishmentId: id,
    //      active: active
    //    }
    //  }).then(res => {
    //    if (!res.data.errors) {
    //      console.log('good')
    //    } else {
    //      console.log(res.data.errors)
    //    }
    //  })
    //},
    deleteEstablishment(id) {
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(destroyEstablishment),
        variables: {
          establishmentId: id,
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }
      }).then(res => {
        if(!res.data.errors) { 
          if (!res.data.data.destroyEstablishment.success) {
            if (res.data.data.destroyEstablishment.code == "unauthorized") {
              this.$vs.notify({
                title: 'No tiene permisos para realizar esta acción',
                time: 3000,
                //text: 'Por favor intente nuevamente',
                color: '#DE3618',
                position: 'top-right',
                icon: 'error'
              })
            } else {
              this.$vs.notify({
                title: 'Ha ocurrido un error',
                time: 3000,
                text: this.$t(`graph.${res.data.data.destroyEstablishment.code}`),
                color: '#DE3618',
                position: 'top-right',
                icon: 'error'
              })
            }
          } else {
            this.$emit('reload-establishments')
          }
          this.deleting = ''
          this.confirmDelete = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    usersEmails (arr) {
      if (arr) {
        return arr.map(user => user.email).join(', ')
      }
    },
    editEstablishment(name) {
      this.$refs.AddEditEstablishments.editEstablishment(name)  //  TODO: cambiar param name a number o a id
    },
    addEstablishment () {
      if (!this.currentUser.roles.filter(role => role.resourceType == 'Establishment').map(e => e.name).includes('admin')) {
        this.$vs.notify({
          title: 'Error',
          time: 8000,
          text: 'Usted no posee permisos para crear un establecimiento.',
          color: '#eb4d4b',
          position: 'top-center',
          icon: 'error'
        })
      } else {
        this.newEstablishment = { country: '', state: '', city: '', status: true }
        this.editing = ''
        this.activePopup = true
        this.$refs.AddEditEstablishments.openPopup()
      }
    }
  }
}
</script>
